// src/components/ObfuscationIndicator.tsx
// Индикатор «обфускации данных» перед обращением к внешней языковой модели (демо).
// Чисто визуальный: крутит под-шаги, пока хук useObfuscationGate держит паузу.
import { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { ShieldCheck } from 'lucide-react';

const SUBSTEPS = [
  'Маскирую персональные данные…',
  'Обезличиваю реквизиты и номера счетов…',
  'Удаляю прямые идентификаторы…',
  'Формирую обезличенный запрос…',
];
const SUBSTEP_INTERVAL_MS = 2200;

export default function ObfuscationIndicator() {
  const [subIndex, setSubIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setSubIndex((prev) => (prev + 1) % SUBSTEPS.length);
    }, SUBSTEP_INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, py: 0.25 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <ShieldCheck size={15} style={{ color: 'var(--color-primary)', flexShrink: 0 }} />
        <Typography sx={{ fontSize: 12.5, fontWeight: 650, color: 'var(--color-text-secondary)' }}>
          Обфускация данных перед отправкой во внешнюю модель
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, pl: 0.25 }}>
        <CircularProgress size={11} sx={{ color: 'var(--color-primary)', flexShrink: 0 }} />
        <Typography sx={{ fontSize: 11.5, color: 'var(--color-text-muted)' }}>
          {SUBSTEPS[subIndex]}
        </Typography>
      </Box>
    </Box>
  );
}
